module.exports = {"150203001":"少先路街道","150203003":"沼潭街道","150203004":"林荫路街道","150203005":"友谊大街街道","150203006":"阿尔丁大街街道","150203007":"团结大街街道","150203008":"鞍山道街道","150203009":"前进道街道","150203010":"市府东路街道","150203011":"白云路街道","150203012":"黄河西路街道","150203013":"昆工路街道","150203014":"昆北街道","150203100":"昆河镇","150203102":"卜尔汉图镇","150203400":"包钢厂区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/150203.json
// module id = 359
// module chunks = 0